var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.1706 15.275C12.6056 15.275 15.0306 11.6 15.0306 8.41498C15.0306 8.30998 15.0306 8.20498 15.0256 8.10498C15.4956 7.76498 15.9056 7.33998 16.2306 6.85498C15.8006 7.04498 15.3356 7.17498 14.8456 7.23498C15.3456 6.93498 15.7256 6.46498 15.9056 5.89998C15.4406 6.17498 14.9256 6.37498 14.3756 6.48498C13.9356 6.01498 13.3106 5.72498 12.6156 5.72498C11.2856 5.72498 10.2056 6.80498 10.2056 8.13498C10.2056 8.32498 10.2256 8.50998 10.2706 8.68498C8.2656 8.58498 6.4906 7.62498 5.3006 6.16498C5.0956 6.51998 4.9756 6.93498 4.9756 7.37498C4.9756 8.20998 5.4006 8.94998 6.0506 9.37998C5.6556 9.36998 5.2856 9.25998 4.9606 9.07998C4.9606 9.08998 4.9606 9.09998 4.9606 9.10998C4.9606 10.28 5.7906 11.25 6.8956 11.475C6.6956 11.53 6.4806 11.56 6.2606 11.56C6.1056 11.56 5.9556 11.545 5.8056 11.515C6.1106 12.475 7.0006 13.17 8.0556 13.19C7.2306 13.835 6.1906 14.22 5.0606 14.22C4.8656 14.22 4.6756 14.21 4.4856 14.185C5.5406 14.875 6.8106 15.275 8.1706 15.275Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterIcon);
export default __webpack_public_path__ + "static/media/twitterIcon.315198ad2c6c274c98ae0cab5534ad34.svg";
export { ForwardRef as ReactComponent };